import React from 'react';
import { LucideIcon } from 'lucide-react';

interface SectionHeadingProps {
	icon: LucideIcon;
	title: React.ReactNode;
	/** Acción opcional a la derecha (p. ej. el botón "Cambiar plan"). */
	action?: React.ReactNode;
}

/**
 * Cabecera de sección: icono en caja verde + título, con acción opcional a la derecha.
 * Rompe el ritmo entre grupos de cards con una estética consistente en toda la vista.
 */
const SectionHeading: React.FC<SectionHeadingProps> = ({ icon: Icon, title, action }) => (
	<div className="flex items-center justify-between gap-3">
		{/* El icono cuelga a la izquierda (outdent) en desktop para separar secciones;
		    el título queda alineado con las cards de debajo. */}
		<div className="flex min-w-0 items-center gap-2.5 lg:-ml-11">
			<div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10">
				<Icon className="h-4 w-4 text-primary" />
			</div>
			<h2 className="font-heading text-lg font-semibold leading-tight">{title}</h2>
		</div>
		{action}
	</div>
);

export default SectionHeading;
